const AppForm = {
    PersonalData: Symbol('personaldata')
    ,Address: Symbol('address')
    ,Questions: Symbol('questions')
    ,Message: Symbol('message')
	,ThirdParty: Symbol('thirdparty')
    ,Success: Symbol('success')
    ,KBAFailure: Symbol('kbafailure')
    ,KBALimitReached: Symbol('kbablocked')
    ,FileSizeLimitExceeded: Symbol('filesize')
    ,Error: Symbol('error')
}

export default AppForm;